var envValue = 'online';

// if (process.env.NODE_ENV === 'development') {
//   envValue = 'dev';
// }

let host = window.location.host;
var local =
  /192\.168\./.test(host) || /127\.0\./.test(host) || /localhost/.test(host);
let demo = /test/.test(host);

if (local || demo) {
  envValue = 'dev';
}

const apiConfig = {
  api1: {
    dev: 'https://rtoken-api.stafi.io',
    online: 'https://rtoken-api.stafi.io'
  },
  stafiChain: {
    dev: 'wss://stafi-seiya.stafi.io',
    online: 'wss://mainnet-rpc.stafi.io'
  }
};

const constantConfig = {
  FISTokenAddress: {
    dev: '0x64591e3f2dbf46cdfb398a0d9ba81f41b7cbd449',
    online: '0xef3a930e1ffffacd2fc13434ac81bd278b0ecc8d'
  },
  rFISTokenAddress: {
    dev: '0xc372e985fda306cfe0e903657de808cf757f536f',
    online: '0xc82eb6dea0c93edb8b697b89ad1b13d19469d635'
  },
  rKSMTokenAddress: {
    dev: '0xd1d458c1c3579033a65db4ca2f06c12573aa5e27',
    online: ''
  },
  bridgeAddress: {
    dev: '0x57e7c280a3828bf9a5356d7c926fcd555cf0bdc8',
    online: '0x13ef51f0525df6045267baed411f535d86586bc1'
  },
  erc20HandlerAddress: {
    dev: '0xeab816f88fe0ebae4971e33f3a21e34ff695791b',
    online: '0x91c48208a9a171eb26e6f2bd48f41b958e19ebab'
  },
  rETHTokenAddress: {
    dev: '0x680ab46340aa2189515b49fd35ac8a5bd66e78de',
    online: '0x9559aaa82d9649c7a7b220e7c461d2e74c9a3593'
  },
  stafiUserDepositAddress: {
    dev: '0x310b80843c56591bd3c403f877ab665f68530cef',
    online: '0x430cf6dd3e289adae63b50ff661d6bba2dbb3f28'
  },
  stafiNodeDepositAddress: {
    dev: '0x0313d2b2e9ef926012881a7e33482a957bed265c',
    online: '0x50db2ce93c8b1f6771c985b6b840b587349496a0'
  },
  stafiStakingPoolManagerAddress: {
    dev: '0xa84ec99b9c9d16f769d9909a2466923f4dddd282',
    online: '0x1c9890c9cb9925a8651c10b5f557d744bafbed5a'
  },
  stafiStakingPoolQueueAddress: {
    dev: '0xc8985dd9da3c9d35eaac6b29b5f6b7ecc3f765ca',
    online: '0xc59ea6cebb8089a0330800f50946610977c4fc96'
  }
};

let apis = {};
for (let key in apiConfig) {
  let item = apiConfig[key];
  apis[key] = item[envValue] || item['online'] || item['dev'] || item['local'];
}

let constants = {};
for (let key in constantConfig) {
  let item = constantConfig[key];
  constants[key] =
    item[envValue] || item['online'] || item['dev'] || item['local'];
}

const envConfig = {
  env: envValue,
  apis: apis,
  constants: constants
};

export default envConfig;
